import './print.css';

export const NoPrint = ({ children, force, ...rest }) => {
  if (!force) return <>{children}</>;

  return (
    <div className="rep-no-print-force" {...rest}>
      {children}
    </div>
  );
};

export const Print = ({ children, name, ...rest }) => (
  <div className="rep-print" data-print-name={name} {...rest}>
    {children}
  </div>
);

const PrintProvider = ({ children }) => <>{children}</>;

export default PrintProvider;
